
import React, { useState } from "react";
import "./pagestyles/CookieSettings.css";

const CookieSettings = () => {
  const [cookies, setCookies] = useState({
    necessary: true,
    analytics: false,
    marketing: false,
    functional: false,
  });

  const handleToggle = (type) => {
    setCookies({ ...cookies, [type]: !cookies[type] });
  };

  const handleSave = () => {
    localStorage.setItem("cookieSettings", JSON.stringify(cookies));
    alert("Your cookie preferences have been saved.");
  };

  return (
    <div className="cookie-container">
      <div className="cookie-header">
        <h1>Cookie Settings</h1>
        <p>Manage how cookies are used on this website.</p>
      </div>

      <div className="cookie-section">
        <h2>What Are Cookies?</h2>
        <p>
          Cookies are small text files stored on your device when you visit a
          website. They help improve user experience, remember preferences, and
          analyze website traffic.
        </p>
      </div>

      <div className="cookie-section">
        <h2>Manage Your Preferences</h2>

        <div className="cookie-option">
          <div>
            <h3>Strictly Necessary Cookies</h3>
            <p>These cookies are essential for the website to function.</p>
          </div>
          <input
            type="checkbox"
            checked={cookies.necessary}
            disabled
          />
        </div>

        <div className="cookie-option">
          <div>
            <h3>Analytics Cookies</h3>
            <p>Help us understand how visitors interact with our website.</p>
          </div>
          <input
            type="checkbox"
            checked={cookies.analytics}
            onChange={() => handleToggle("analytics")}
          />
        </div>

        <div className="cookie-option">
          <div>
            <h3>Functional Cookies</h3>
            <p>Remember your preferences and improve functionality.</p>
          </div>
          <input
            type="checkbox"
            checked={cookies.functional}
            onChange={() => handleToggle("functional")}
          />
        </div>

        <div className="cookie-option">
          <div>
            <h3>Marketing Cookies</h3>
            <p>Used to deliver personalized advertisements.</p>
          </div>
          <input
            type="checkbox"
            checked={cookies.marketing}
            onChange={() => handleToggle("marketing")}
          />
        </div>
      </div>

      <div className="cookie-buttons">
        <button className="accept-btn" onClick={handleSave}>
          Save Preferences
        </button>

        <button
          className="reject-btn"
          onClick={() =>
            setCookies({
              necessary: true,
              analytics: false,
              marketing: false,
              functional: false,
            })
          }
        >
          Reject Optional Cookies
        </button>
      </div>
    </div>
  );
};

export default CookieSettings;